export default {"src":"/_next/static/media/coconutmeat.22386eb2.svg","height":681,"width":681,"blurWidth":0,"blurHeight":0};